import React from "react";
import ExpensesTable from "./expensesTable";
import AddExpensesModal from "./addExpensesModal";
import ConfirmationModal from "../Common/confirmationModal";
import moment from "moment";
import Card from "../Common/Card";
import ExpensesReport from "../Dashboard/expenseReport";
let maxDate = moment().format("YYYY-MM-DD");

export default function Expenses({
  expense,
  onDelete,
  expenses,
  onDeleteExpense,
  onChange,
  onClickAdd,
  resetState,
  stateData,
  selectedExpense,
  selected,
  userData,
  onClickEdit,
  onClickClose,
  onClickSearch,
  expensesReport,
}) {
  return (
    <>
      {/* <div className="comp-heading">
        <div className="row">
          <div className="col-lg-4">
            <label>Expenses</label>
          </div>
          <div className="col-lg-5"></div>
          <div className="col-lg-3" style={{ textAlign: "right" }}>
            <button
              className="btn btn-success btn-sm"
              data-toggle="modal"
              data-target="#add-expense-modal"
            >
              Add Expenses
            </button>
          </div>
        </div>
      </div>
      <br /> */}
      <div className="row">
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="date">Date From</label>
            <input
              onChange={(e) => onChange(e)}
              className="form-control"
              type="date"
              id="dateFrom"
              max={maxDate}
              value={
                stateData && stateData.dateFrom
                  ? moment(stateData.dateFrom).format("YYYY-MM-DD")
                  : ""
              }
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="date">Date To</label>
            <input
              onChange={(e) => onChange(e)}
              className="form-control"
              type="date"
              id="dateTo"
              max={maxDate}
              min={
                stateData && stateData.dateFrom
                  ? moment(stateData.dateFrom).format("YYYY-MM-DD")
                  : null
              }
              value={
                stateData && stateData.dateTo
                  ? moment(stateData.dateTo).format("YYYY-MM-DD")
                  : ""
              }
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label></label>
            <br />
            <button
              disabled={
                stateData && stateData.dateFrom && stateData.dateTo
                  ? ""
                  : "disabled"
              }
              style={{ marginTop: "5px" }}
              className="btn btn-primary"
              onClick={() => onClickSearch()}
            >
              Search
            </button>
          </div>
        </div>
        <div className="col-sm-2" style={{ textAlign: "right" }}>
          <div className="form-group">
            <label></label>
            <button
              style={{ marginTop: "30px" }}
              className="btn btn-success btn-sm"
              data-toggle="modal"
              data-target="#add-expense-modal"
            >
              Add Expenses
            </button>
          </div>
        </div>
      </div>
      <div className="panel panel-default">
        <div className="panel-body">
          <ExpensesTable
            onClickEdit={(expense) => onClickEdit(expense)}
            userData={userData}
            expenses={expenses}
            onDeleteExpense={(expense) => onDeleteExpense(expense)}
            selected={selected}
          />
        </div>
      </div>
      <AddExpensesModal
        onChange={(e) => onChange(e)}
        selectedExpense={selectedExpense}
        stateData={stateData}
        onClickAdd={() => onClickAdd()}
        onClickClose={() => onClickClose()}
        resetState={() => resetState()}
      />
      <ConfirmationModal item={expense} onDelete={() => onDelete()} />
      <div className="row">
        <div className="col-sm-8"></div>
        <div className="col-sm-4">
          <Card>
            <h5>Expenses Report</h5>
            <hr />
            {expensesReport ? (
              <ExpensesReport report={expensesReport} />
            ) : (
              <div className="no-data">
                <i>No data</i>
              </div>
            )}
          </Card>
        </div>
      </div>
    </>
  );
}
